import { Box, Stack, Typography } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';
import { COLORS } from '@/styles/tokens/colors';

import { EducationalSlideH3 } from '../../components/EducationalSlide.components';
import { SVGVariableContainer } from '../../components/SVGVariableContainer';
import QPRTDiagram from './QPRTDiagram.svg?react';

export function QprtOverviewPageTwo() {
  return (
    <Stack direction="row" spacing={5} height="100%">
      <Card
        variant="filled"
        sx={{ p: 2, width: '35%', height: '100%', overflowY: 'auto' }}
      >
        <EditableRegion regionId="qprt-overview-page-two-list" />
      </Card>
      <Stack sx={{ width: '65%', alignItems: 'center' }}>
        <Box
          sx={{
            border: `1px solid ${COLORS.NEUTRAL_GRAY[200]}`,
            height: '500px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <Box mb={2} mt={2}>
            <EducationalSlideH3>How a QPRT works</EducationalSlideH3>
          </Box>
          <SVGVariableContainer>
            <QPRTDiagram />
          </SVGVariableContainer>
          <Stack alignSelf="flex-start" pl={2} pb={1} mt="auto">
            <Typography
              variant="body-xs"
              sx={{
                fontSize: '10px',
                fontWeight: 400,
                color: COLORS.PRIMITIVES.BLACK,
              }}
            >
              *If grantor continues to live in the home after term end
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
}
